import client from './client';

export type ThemeName = 'modern' | 'dark' | 'sepia' | 'windows-retro';
export type Density = 'comfortable' | 'compact';

export interface UiPrefs {
  ui_theme: ThemeName;
  ui_density: Density;
}

export async function getUiPrefs(): Promise<UiPrefs> {
  const r = await client.get<UiPrefs>('/auth/me/ui-prefs');
  return r.data;
}

export async function putUiPrefs(body: Partial<UiPrefs>): Promise<UiPrefs> {
  const r = await client.put<UiPrefs>('/auth/me/ui-prefs', body);
  return r.data;
}
